import { Button, Checkbox, Drawer, Label } from "@components";
import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import classNames from "classnames";
import OcdpAPI2 from "providers/OcdpAPI2";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";
const css = classNames.bind(styles);

const ocdp_api = new OcdpAPI2();

export default function OrderMarkups({ order, loadCustomer }) {
  const [openMarkups, setOpenMarkups] = useState(false);
  const [markups, setMarkups] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedMarkups, setSelectedMarkups] = useState([]);

  useEffect(() => {
    const fetchMarkups = async () => {
      const markups = await ocdp_api.getMarkups();
      setMarkups(markups);
    };

    fetchMarkups();
  }, []);

  useEffect(() => {
    if (order) setSelectedMarkups(order?.order_tags || []);
  }, [order]);

  const filteredMarkups = markups.filter((markup) => {
    if (markup.type !== "ORDER") return false;

    return markup.name.toLowerCase().includes(search.toLowerCase());
  });

  const saveMarkupsToOrder = async () => {
    const response = await ocdp_api.assignMarkupToOrder(
      order.order_id,
      selectedMarkups.filter((m) => m.id).map((m) => m.id),
    );

    if (response?.getCode() !== 200)
      alert({
        text: response?.message || "Erro ao salvar marcações",
        buttonText: "Ok",
      });
    else {
      alert({
        text: "Salvo com sucesso!",
        buttonText: "Ok",
      });
      setOpenMarkups(false);
      loadCustomer();
    }
  };

  return (
    <div className={styles.orderMarkups}>
      <div className="d-flex align-center">
        <p className={styles.title}>
          Marcações do pedido ({selectedMarkups.length})
        </p>
        <If cond={selectedMarkups.length === 0}>
          <Button
            onClick={() => setOpenMarkups(true)}
            className={css({
              "w-100": selectedMarkups.length === 0,
              "gap-10": true,
            })}
            design="default-2"
          >
            <i className="fal fa-plus" />
            <span>Adicionar marcação</span>
          </Button>
        </If>
      </div>

      <If cond={selectedMarkups.length > 0}>
        <div className={styles.tags}>
          {(selectedMarkups || []).map((tag) => (
            <div className={styles.tag}>
              <div
                className={styles.color}
                style={{ backgroundColor: tag.color }}
              />
              <i className="fal fa-tags" style={{ color: tag.color }} />
              <p>{tag.name}</p>
            </div>
          ))}
        </div>
      </If>

      <If cond={selectedMarkups.length > 0}>
        <Button
          onClick={() => setOpenMarkups(true)}
          className={css({
            "w-100": selectedMarkups.length === 0,
            "gap-10": true,
          })}
          design="default-2"
        >
          <i className="fal fa-plus" />
          <span>Gerenciar marcações</span>
        </Button>
      </If>

      <Drawer
        visible={openMarkups}
        onClose={() => setOpenMarkups(false)}
        title="Marcações de pedido"
        subtitle="Histórico"
        showBackButton
        alreadyDrawer
        withoutTransition
        backButton={() => setOpenMarkups(false)}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={saveMarkupsToOrder}
          >
            Salvar
          </Button>
        }
      >
        <Label>
          Marcações ({(markups.filter((m) => m.type === "ORDER") || []).length})
        </Label>
        <InputSearch
          design="two"
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className={styles.markups}>
          {filteredMarkups.map((m) => (
            <div
              key={m.id}
              className={styles.markup}
              onClick={() =>
                setSelectedMarkups((prev) => {
                  if (prev.find((p) => p.id === m.id)) {
                    return prev.filter((p) => p.id !== m.id);
                  }
                  return [...prev, m];
                })
              }
            >
              <div className="d-flex align-center h-100">
                <div
                  className={styles.color}
                  style={{ backgroundColor: m.color }}
                />
                <Checkbox
                  readOnly
                  checked={selectedMarkups.find((p) => p.id === m.id)}
                  value={m.id}
                />
                <div className={styles.tag}>
                  <i className="fal fa-tags" />
                </div>
                <p>{m.name}</p>
              </div>
            </div>
          ))}
        </div>
      </Drawer>
    </div>
  );
}
